import { Circle } from "@chakra-ui/react";
import React from "react";
import { type CircleProps } from "./circle-progress";
import { ProgressBlur } from "./progress-blur";

export function BackgroundCircle({ size, strokeWidth, percentage }: CircleProps) {
  return (
    <Circle size={size} border={`${strokeWidth}px solid`} borderColor="base.background" overflow="hidden">
      <ProgressBlur size={size} strokeWidth={strokeWidth / 1.5} percentage={percentage} />
    </Circle>
  );
}
